/*
 * @Copyright 2020. Institute for Future Intelligence, Inc.
 * @author Charles Xie
 */

import {Block} from "./Block";
import {database} from "../Main";

export abstract class BoardBlock extends Block {

  synched: boolean = false;
  remoteKey: string;

  setSynched(synched: boolean): void {
    this.synched = synched;
  }

  isSynched(): boolean {
    return this.synched;
  }

  setRemoteKey(remoteKey: string): void {
    if (this.remoteKey !== remoteKey) {
      database.reference.ref(this.remoteKey).off();
      this.remoteKey = remoteKey;
      this.linkRemote();
    }
  }

  getRemoteKey(): string {
    return this.remoteKey;
  }

  // by default, sensors transmit data every second. This can be adjusted through Firebase.
  abstract linkRemote(): void;

  abstract updateRemote(value): void;

}
